<template>
    <div :class="{ dn : !visible }">
        <slot></slot>
    </div>
</template>
<script>
    export default {
        props: {
            name: {
                type: String,
                required: true
            },
            isVisible: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                visible: this.isVisible
            }
        }
    };
</script>